import { FC } from 'react';
import { Tag, Tooltip } from 'antd';
import { MapData_ProcessStatus, MapData_ModelUtil } from '~/common/typescript/models/MapData';
import { CheckCircleOutlined, ClockCircleOutlined, ExclamationCircleOutlined, SyncOutlined } from '@ant-design/icons';

interface MapDataStatusTagProps {
  status: MapData_ProcessStatus;
  hideLabel?: boolean;
}

const getStatusIcon = (status: MapData_ProcessStatus) => {
  switch (status) {
    case MapData_ProcessStatus.PENDING:
    case MapData_ProcessStatus.SUBMITED:
    case MapData_ProcessStatus.WAITING_USER_INPUT:
      return <ClockCircleOutlined />;
    case MapData_ProcessStatus.PROCESSING:
      return <SyncOutlined spin />;
    case MapData_ProcessStatus.SUCCESS:
      return <CheckCircleOutlined />;
    case MapData_ProcessStatus.FAILED:
      return <ExclamationCircleOutlined />;
    default:
      return null;
  }
};

const MapDataStatusTag: FC<MapDataStatusTagProps> = ({ status, hideLabel }) => {
  const isSuccessOrFailed =
    status === MapData_ProcessStatus.SUCCESS || status === MapData_ProcessStatus.FAILED;
  const showText = !hideLabel && !isSuccessOrFailed;
  const text = MapData_ModelUtil.getTextStatus(status);

  return (
    <Tooltip title={text}>
      <Tag
        icon={getStatusIcon(status)}
        color={MapData_ModelUtil.getStatusColor(status)}
        style={{
          fontSize: '11px',
          padding: showText ? '1px 5px' : '1px 4px',
          marginInlineEnd: 0,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {showText ? text : null}
      </Tag>
    </Tooltip>
  );
};

export default MapDataStatusTag;
